import axios from "axios";
import { store } from "../redux/store";
import { logout } from "../redux/actions/actions";
import { toast } from "react-toastify";

const Axios = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

// Utility function to handle logout and redirection
const handleLogout = () => {
  toast.error("Your session has expired! Please log in again");
  localStorage.removeItem("persist:rootecom");
  setTimeout(() => {
    window.location.href = "/login";
  }, 3000);
};

Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      handleLogout();
    }
    return Promise.reject(error); 
  }
);

export default Axios;
